import request from "@/http/request"
import {
    addPlan,
    deletePlan,
    editPlan,
    editPlanState,
    getList,
    getPlan,
    getSelectPlan,
    getPlanStudent,
    getPlanCode,
    regionImport,
    deleteRegion,
    editRegion,
    getCurrentPlan,
    uploadEntranceTemplate,
    entrancePrintTest,
    copyLastPlanFiles,
    paymentPicture,
    uploadCertificateTemplate,
    getTenantSmsTitleList,
    stopPlan,
    getRegisterForm,
    selectByOne,
    entrancePrint,
    certificatePrint,
    getConfigData,
    updateAuditState,
    getScoreReview,
    getNextScoreReview,
    exportData,
    getPlanSignDateCount,
    getTourTeacherSession,
    getTourTeacherPlace,
    getTourTeacherList,
    tourTeacherImport,
    getTourTeacherAddList,
    addTourTeacher,
    delTourTeacher,
    getUserHistoryPhoto,
    examTypeList,
    checkOtherSessionAndCopy,
    checkTeacherIsSet,
    singleCopy,
    copy,
    updatePlanPhotoSet,
    photoVerifyLog,
    photoVerifyLogDelete
} from '@/http/api'

export const photoVerifyLogDeleteAPI = (data) => {
    return request({
        url: photoVerifyLogDelete,
        data
    })
}
export const photoVerifyLogAPI = (data) => {
    return request({
        url: photoVerifyLog,
        data
    })
}
export const copyApi = (data) => {
    return request({
        url: copy,
        data
    })
}
export const updatePlanPhotoSetApi = (data) => {
    return request({
        url: updatePlanPhotoSet,
        data
    })
}

export const singleCopyApi = (data) => {
    return request({
        url: singleCopy,
        data
    })
}

export const checkTeacherIsSetApi = (data) => {
    return request({
        url: checkTeacherIsSet,
        data
    })
}

export const checkOtherSessionAndCopyApi = (data) => {
    return request({
        url: checkOtherSessionAndCopy,
        data
    })
}


export const getUserHistoryPhotoApi = (data) => {
    return request({
        url: getUserHistoryPhoto,
        data
    })
}
export const examTypeListApi = (data) => {
    return request({
        url: examTypeList,
        data
    })
}
export const RegisterForm = (data) => {
    return request({
        url: getRegisterForm,
        data
    })
}
export const ConfigData = (data)=>{
    return request ({
        url:getConfigData,
        data
    })
}
export const trancePrint = (data) => {
    return request({
        url: entrancePrint,
        data
    })
}
export const catePrint = (data) => {
    return request({
        url: certificatePrint,
        data
    })
}
export const selectUserInfo = () => {
    return request({
        url: selectByOne,
    })
}
export const uploadCertificate = (data) => {
    return request({
        url: uploadCertificateTemplate,
        isUpload: true,
        data
    })
}
export const getTenantSmsTitle = (data) => {
    return request({
        url: getTenantSmsTitleList,
        isUpload: true,
        data
    })
}
export const copyLastPlanFile = () => {
    return request({
        url: copyLastPlanFiles,
    })
}
export const getPagePlan = (data) => {
    return request({
        url: getList,
        data
    })
}
export const editPlanStateFn = (data) => {
    return request({
        url: editPlanState,
        data
    })
}
export const addPlanFn = (data) => {
    return request({
        url: addPlan,
        data
    })
}
export const deletePlanFn = (data) => {
    return request({
        url: deletePlan,
        data
    })
}
export const editPlanFn = (data) => {
    return request({
        url: editPlan,
        data
    })
}
export const getPlanCodeFn = () => {
    return request({
        url: getPlanCode
    })
}
export const getPlanStudentFn = (data) => {
    return request({
        url: getPlanStudent,
        data
    })
}
export const importStudent = (data) => {
    return request({
        url: regionImport,
        isUpload: true,
        data
    })
}
export const deleteStudentFn = (data) => {
    return request({
        url: deleteRegion,
        data
    })
}
export const editStudentFn = (data) => {
    return request({
        url: editRegion,
        data
    })
}
export const getSinglePlan = (data) => {
    return request({
        url: getPlan,
        data
    })
}
export const getCurrentPlanFn = (data) => {
    return request({
        url: getCurrentPlan,
        data
    })
}
export const getSelectPlanFn = (data) => {
    return request({
        url: getSelectPlan,
        data
    })
}
export const importEntranceTemplate = (data) => {
    return request({
        url: uploadEntranceTemplate,
        isUpload: true,
        data
    })
}
export const showEntrance = (data) => {
    return request({
        url: entrancePrintTest,
        data
    })
}
export const stopPlanFn = (data) => {
    return request({
        url: stopPlan,
        data
    })
}
export const uploadPayPic = (data) => {
    return request({
        url: paymentPicture,
        isUpload: true,
        data
    })
}
export const passthroughState = (data) => {
    return request({
        url: updateAuditState,
        data
    })
  }
export const usergetScoreReview = (data) => {//学生，下载申诉表模板
    return request({
        url: getScoreReview,
        data
    })
}
export const ScoreReview = (data) => {//学生，下载申诉表模板
    return request({
        url: getNextScoreReview,
        data
    })
}
export const exportDataimg = (data) => {//学生，下载申诉表模板
    return request({
        url: exportData,
        data
    })
}
export const getPlanSignDateCountShow = (data) => {//学生，下载申诉表模板
    return request({
        url: getPlanSignDateCount,
        data
    })
}
export const getTourTeacherSessionList = (data) => {//学生，下载申诉表模板
    return request({
        url: getTourTeacherSession,
        data
    })
}
export const getTourTeacherPlaceList = (data) => {
    return request({
        url: getTourTeacherPlace,
        data
    })
}
export const getTourTeacherListFn = (data) => {
    return request({
        url: getTourTeacherList,
        data
    })
}
export const tourTeacherImportExcel = (data) => {
    return request({
        url: tourTeacherImport,
        data,
        isUpload: true,
    })
}
export const getTourTeacherAddListFn = (data) => {
    return request({
        url: getTourTeacherAddList,
        data
    })
}
export const addTourTeacherFn = (data) => {
    return request({
        url: addTourTeacher,
        data
    })
}
export const delTourTeacherFn = (data) => {
    return request({
        url: delTourTeacher,
        data
    })
}
